// Modal d'attribution d'une note (0 à 6) sur une cellule élève × compétence.
// N'envoie rien à l'API : la note part dans le lot en attente d'EvalDetail
// (onScoreChange) et sera sauvegardée groupée via mass_update_scores.
import React, { useState } from "react";
import { useRef, useEffect } from "react";
const CompForEval = ({ handleClose, show, eleveId, esfId, onScoreChange, setStoredResultatEval }) => {
     const [selectedGrade, setSelectedGrade] = useState(null);
    const modalRef = useRef(null);

    useEffect( ()=> {
        if(show){
            modalRef.current.focus();
        }
    })

     const getGradeStyles = (value) => {
    const styleMap = {
      0: {
        borderColor: '#9ca3af',
        hoverBg: '#f9fafb',
        selectedBg: '#f3f4f6',
        shadow: 'rgba(156, 163, 175, 0.3)'
      },
      1: {
        borderColor: '#dc2626',
        hoverBg: '#fef2f2',
        selectedBg: '#fee2e2',
        shadow: 'rgba(220, 38, 38, 0.3)'
      },
      2: {
        borderColor: '#ea580c',
        hoverBg: '#fff7ed',
        selectedBg: '#fed7aa',
        shadow: 'rgba(234, 88, 12, 0.3)'
      },
      3: {
        borderColor: '#d97706',
        hoverBg: '#fffbeb',
        selectedBg: '#fde68a',
        shadow: 'rgba(217, 119, 6, 0.3)'
      },
      4: {
        borderColor: '#06b6d4',
        hoverBg: '#f0fdfa',
        selectedBg: '#a7f3d0',
        shadow: 'rgba(6, 182, 212, 0.3)'
      },
      5: {
        borderColor: '#059669',
        hoverBg: '#f0fdf4',
        selectedBg: '#bbf7d0',
        shadow: 'rgba(5, 150, 105, 0.3)'
      },
      6: {
        borderColor: '#047857',
        hoverBg: '#ecfdf5',
        selectedBg: '#86efac',
        shadow: 'rgba(4, 120, 87, 0.3)'
      }
    };
    return styleMap[value];
  };

   const grades = [
    { value: 0, label: 'Non notée', color: 'transparent' },
    { value: 1, label: 'Maîtrise insuffisante', color: '#ef4444' },
    { value: 2, label: 'Début de maîtrise', color: '#f97316' },
    { value: 3, label: 'Maîtrise fragile', color: '#eab308' },
    { value: 4, label: 'Presque maîtrisé', color: '#14b8a6' },
    { value: 5, label: 'Maîtrise satisfaisante', color: '#22c55e' },
    { value: 6, label: 'Très bonne maitrîse', color: '#15803d' }
  ];

// Saisie clavier 0-6 quand la modal est ouverte sur une cellule : la note part
// dans le lot en attente d'EvalDetail et l'affichage local est mis à jour
// aussitôt (la navigation vers la cellule suivante lit ce state).
useEffect(() => {     
    const handleGlobalKeyDown = async (e) => {         
        const value = e.key;          

        if (value==='0' || value === '1' || value === '2' || value === '3' || value === '4' || value === '5' || value === '6'){             
            const numValue = value !== '0' ? parseInt(value) : 0;                          
            
            onScoreChange(eleveId, esfId, numValue);
            
            setStoredResultatEval(prev => {
                const updatedEleveResultats = prev.eleves_resultats.map(eleve => {
                    if (eleve.id === eleveId) {
                        const updatedResultats = eleve.resultats.map(resultat => {
                            if (resultat.esfId === esfId) {
                                return { ...resultat, scores: numValue !== 0 ? numValue : null };
                            }
                            return resultat;
                        });
                        return { ...eleve, resultats: updatedResultats };
                    }
                    return eleve;
                });
                
                return { ...prev, eleves_resultats: updatedEleveResultats };
            });
            
            handleClose("reload");
        }     
    };        

    if(esfId) {         
        window.addEventListener('keydown', handleGlobalKeyDown);     
    }      

    return () => {         
        window.removeEventListener('keydown', handleGlobalKeyDown);     
    }; 
}, [eleveId, esfId, handleClose, onScoreChange, setStoredResultatEval]);
      
    
const handleClick = (grade) => {
    setSelectedGrade(grade);
    
    onScoreChange(eleveId, esfId, grade);
    
    setStoredResultatEval(prev => {
        // Cherche l'élève et la compétence spécifique dans le tableau des résultats
        const updatedEleveResultats = prev.eleves_resultats.map(eleve => {
            if (eleve.id === eleveId) {
                const updatedResultats = eleve.resultats.map(resultat => {
                    if (resultat.esfId === esfId) {
                        return { ...resultat, scores: grade !== 0 ? parseInt(grade) : null };
                    }
                    return resultat;
                });
                return { ...eleve, resultats: updatedResultats };
            }
            return eleve;
        });
        
        return { ...prev, eleves_resultats: updatedEleveResultats };
    });

    setSelectedGrade('');

    // "reload" : EvalDetail enchaîne aussitôt sur la cellule suivante.
    handleClose("reload");
};

  
    return (
       show &&   <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
        <div 
                ref={modalRef}
                tabIndex={-1}
                className="bg-white rounded-3xl shadow-2xl flex flex-col items-center w-full max-w-md max-h-[90vh] overflow-y-auto"
                style={{
                    background: 'linear-gradient(135deg, #f8f9ff 0%, #f5f7ff 100%)',
                }}
            >
                {/* Header */}
                <div
                    className="relative w-full p-5 sm:p-8 text-center text-white"
                    style={{
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    }}
                >
                    <div 
                        className="absolute left-1/2 w-0 h-0"
                        style={{
                            bottom: '-10px',
                            transform: 'translateX(-50%)',
                            borderLeft: '15px solid transparent',
                            borderRight: '15px solid transparent',
                            borderTop: '10px solid #00f2fe'
                        }}
                    />
                    <h2 className="text-2xl font-semibold mb-2">📝 Évaluation par Compétences</h2>
                    <p className="text-sm" style={{ opacity: 0.9 }}>Sélectionnez le niveau de maîtrise</p>
                </div>
{/* Content */}
        <div className="p-5 sm:p-8 xl:text-base text-xs space-y-3 sm:space-y-4">
          {grades.map((grade, index) => {
            const styles = getGradeStyles(grade.value);
              const isSelected = selectedGrade === grade.value; // ✅ On vérifie qui a été selectionné ici !
            
            return (
              <div
                key={grade.value}
                onClick={() => handleClick(grade.value)}
                className={`
                  flex items-center gap-4 p-5 border-2 rounded-2xl cursor-pointer 
                  transition-all duration-300 ease-out relative group
                  hover:shadow-lg hover:scale-[1.02] hover:translate-x-2
                  ${isSelected 
                    ? `border-[${styles.borderColor}] shadow-lg scale-[1.02]` 
                    : 'border-gray-200 hover:border-gray-300'
                  }
                `}
                style={{
                  backgroundColor: isSelected ? styles.selectedBg : 'white',
                  borderColor: isSelected ? styles.borderColor : undefined,
                  boxShadow: isSelected ? `0 8px 25px ${styles.shadow}` : undefined,
                  animationDelay: `${index * 0.05}s`
                }}
              >
                {/* Colored dot */}
                <div 
                  className="w-6 h-6 rounded-full flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: grade.color }}
                />
                
                {/* Grade text */}
                <div className="flex-1 font-medium text-gray-700">
                  {grade.label}
                </div>
                
                {/* Grade value */}
                <div className="bg-gray-100 text-gray-600 font-bold text-lg px-3 py-1 rounded-lg min-w-[2.5rem] text-center">
                  {grade.value}
                </div>
              </div>
            );
          })}
        </div>
             

          <button
            type="button"
            onClick={handleClose}
             className="px-10 py-4 rounded-xl  mb-2
             text-base font-semibold cursor-pointer transition-all 
             duration-300 uppercase hover:-translate-y-1 tracking-wide text-white border-none disabled:opacity-50 bg-gradient-to-r from-orange-500 to-orange-600"
                       
          >
            ✓ Fermer
          </button>
        </div>
      </div>

     
    );
  };


  export default CompForEval;
